import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e24d880"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 환급금은 왜 발생할까요? ")
const _hoisted_2 = { class: "info-calculation box" }
const _hoisted_3 = { class: "text-area" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" A.I 환급 솔루션의 정확한 계산 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 업계 최고 세무 전문가들과 IT 개발자들이 개발한 솔루션을 이용해 과다 납부한 세금을 정확하게 조회하고 계산하여 환급금을 빠르게 찾아 냅니다. ")
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info-law box" }
const _hoisted_8 = { class: "text-area" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 자주 바뀌는 세법 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 매년 달라지는 세제 혜택으로 초과 납부한 세금이 발생합니다. ")
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "info-business box" }
const _hoisted_13 = { class: "text-area" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 변하는 사업 상황 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 사업 확장 및 직원 채용 등 상황에 따라 환급 혜택 적용 가능 여부가 결정됩니다. ")
const _hoisted_16 = ["src"]

import { ref, onMounted } from 'vue'

import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET } from '@/styles/variables'

import { getImageUrl } from '@/utils/getImageUrl'

import { setAnimationObserver } from '../libs/observer'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingWhy',
  setup(__props) {

const wrapper = ref()
const showAnimation = ref(false)

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "wrapper"
  }, [
    _createVNode(Text, {
      size: "64px",
      "line-height": "1.25",
      "mobile-size": "30px",
      color: _unref(COLOR_SET).white,
      weight: "700",
      "word-break": "keep-all",
      "text-align": "center",
      class: _normalizeClass(["animation-show", { show: showAnimation.value }])
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["color", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(["info-boxes animation-show delay", { show: showAnimation.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Text, {
            size: "32px",
            "mobile-size": "14px",
            color: _unref(COLOR_SET).white,
            weight: "700"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(Text, {
            size: "24px",
            "mobile-size": "12px",
            color: _unref(COLOR_SET).white
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/ai.png')
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Text, {
            size: "32px",
            "mobile-size": "14px",
            color: _unref(COLOR_SET).white,
            weight: "700"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(Text, {
            size: "24px",
            "mobile-size": "12px",
            color: _unref(COLOR_SET).white
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/tax.png')
        }, null, 8, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(Text, {
            size: "32px",
            "mobile-size": "14px",
            color: _unref(COLOR_SET).white,
            weight: "700"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(Text, {
            size: "24px",
            "mobile-size": "12px",
            color: _unref(COLOR_SET).white
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/business.png')
        }, null, 8, _hoisted_16)
      ])
    ], 2)
  ], 512))
}
}

})